module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "highlights-separator"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('title')))])])]), _vm._v(" "), _c('swiper', {
    ref: "myLatestMapsSwiper",
    staticClass: "mobile-only",
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_vm._l((_vm.homePreviewMaps), function(item) {
    return _c('swiper-slide', {
      key: item.businessId
    }, [_c('a', {
      staticClass: "thumbnail-mobile",
      attrs: {
        "href": item.urlVisor
      }
    }, [_c('div', {
      staticClass: "thumbnail"
    }, [_c('div', {
      staticClass: "image",
      style: ({
        backgroundImage: "url(" + item.thumbnail + ")",
      })
    }), _vm._v(" "), _c('div', {
      staticClass: "caption"
    }, [_c('h3', {
      staticClass: "truncate"
    }, [_vm._v(_vm._s(_vm._f("truncate")(item.nomAplicacio, 30)))]), _vm._v(" "), _c('p', {
      staticClass: "truncate"
    }, [_vm._v(_vm._s(_vm._f("truncate")(item.description, 40)))])]), _vm._v(" "), _c('div', {
      staticClass: "meta"
    }, [_c('i', {
      staticClass: "material-icons"
    }, [_vm._v("favorite_border")]), _c('span', [_vm._v(_vm._s(item.rank))]), _c('span', [_vm._v(_vm._s(_vm._f("dateDay")(item.dataPublicacio)) + "-" + _vm._s(_vm._f("dateMonth")(item.dataPublicacio, _vm.selectedLang)) + "-" + _vm._s(_vm._f("dateYear")(item.dataPublicacio)))])])])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination",
    attrs: {
      "slot": "pagination"
    },
    slot: "pagination"
  })], 2), _vm._v(" "), _c('section', {
    staticClass: "highlights darkblue-theme desktop-only"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('thumbnailmapList', {
    attrs: {
      "maxLengthTitle": 40,
      "maxLengthDesc": 50,
      "homePreviewMaps": _vm.homePreviewMaps,
      "selectedLang": _vm.selectedLang,
      "isMobile": false
    }
  })], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b608d9a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/home-geolocal/components/items-slider/items-slider.vue
// module id = 298
// module chunks = 0